import { render, staticRenderFns } from "./Orgs.vue?vue&type=template&id=c2c11986&scoped=true&"
import script from "./Orgs.vue?vue&type=script&lang=js&"
export * from "./Orgs.vue?vue&type=script&lang=js&"
import style0 from "./Orgs.vue?vue&type=style&index=0&id=c2c11986&scoped=true&lang=css&"
import style1 from "./Orgs.vue?vue&type=style&index=1&id=c2c11986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c11986",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VImg,VRow})
